
export function FacetComponent(documentScope = document) {
    for (let facetComponent of documentScope.querySelectorAll('.facet')) {
        let toggle = facetComponent.querySelector('.toggle');
        let expanded = false;
        toggle.addEventListener('click', function() {
            if (expanded) {
                expanded = false;
                facetComponent.classList.remove('expanded');
                facetComponent.classList.add('collapsed');
                toggle.setAttribute('aria-expanded', 'false');
            }
            else {
                expanded = true;
                facetComponent.classList.remove('collapsed');
                facetComponent.classList.add('expanded');
                toggle.setAttribute('aria-expanded', 'true');
            }
        });
        let form = facetComponent.closest('form');
        for (let input of facetComponent.querySelectorAll('input')) {
            input.addEventListener('change', function() {
                let performDefault = form.dispatchEvent(new SubmitEvent('submit', {
                    'submitter': Array.prototype.find.call(form.querySelectorAll('button[type="submit"], input[type="submit"]'), function(submit) {
                        return submit.checkVisibility();
                    }),
                    'cancelable': true,
                }));
                if (performDefault) {
                    form.submit();
                }
            })
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        FacetComponent(document)
    });
}
else {
    FacetComponent(document);
}
